(() => {
  const FILTER_ID = 'noahq-hero-unified-embolden';
  const STYLE_ID = 'noahq-hero-unified-embolden-style';
  const SVG_ID = 'noahq-hero-unified-embolden-svg';

  const ensureFilter = () => {
    if (document.getElementById(SVG_ID)) return;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = SVG_ID;
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'absolute';
    svg.style.width = '0';
    svg.style.height = '0';
    svg.style.overflow = 'hidden';
    svg.style.pointerEvents = 'none';

    const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.id = FILTER_ID;
    filter.setAttribute('x', '-12%');
    filter.setAttribute('y', '-14%');
    filter.setAttribute('width', '124%');
    filter.setAttribute('height', '128%');
    filter.setAttribute('color-interpolation-filters', 'sRGB');

    const morphology = document.createElementNS('http://www.w3.org/2000/svg', 'feMorphology');
    morphology.setAttribute('in', 'SourceGraphic');
    morphology.setAttribute('operator', 'dilate');
    morphology.setAttribute('radius', '1.45');

    filter.appendChild(morphology);
    defs.appendChild(filter);
    svg.appendChild(defs);
    document.body.prepend(svg);
  };

  const ensureStyle = () => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = `
      html body .noahq-home .noahq-hero h1.noahq-hero-copy,
      html body .noahq-home .noahq-hero h1.noahq-hero-copy > .noahq-hero-copy__line,
      html body .noahq-home .noahq-hero h1.noahq-hero-copy > .noahq-hero-copy__brand {
        -webkit-text-stroke-width: 0 !important;
        -webkit-text-stroke-color: transparent !important;
        paint-order: normal !important;
      }

      html body .noahq-home .noahq-hero h1.noahq-hero-copy > .noahq-hero-copy__line,
      html body .noahq-home .noahq-hero h1.noahq-hero-copy > .noahq-hero-copy__brand {
        filter: url(#${FILTER_ID}) !important;
      }

      html body .noahq-home .noahq-hero h1.noahq-hero-copy.is-glitching > .noahq-hero-copy__line {
        filter: url(#${FILTER_ID}) contrast(1.28) saturate(1.4) !important;
      }
    `;
  };

  const apply = () => {
    if (!document.querySelector('.noahq-home .noahq-hero')) return;
    ensureFilter();
    ensureStyle();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  window.addEventListener('pageshow', apply);
})();
